import { useState, useEffect } from "react";
import { useParams } from "react-router"
import RestInfo from "../components/RestInfo"
import { Search } from "lucide-react"
import { PROXY_SERVER, DELHI_LAT, DELHI_LNG } from "../utils/config";

function flattenItems(cards){
    let items = [];
    for(const c of cards){
        const cardData = c?.card?.card;
        if(!cardData) continue;
        if(cardData.categories){
            items = items.concat(flattenItems(cardData.categories.map((cat)=>({card:{card:cat}}))));
        } else if(cardData.itemCards){
            items = items.concat(cardData.itemCards.map((item)=>item?.card?.info).filter(Boolean));
        }
    }
    return items;
}

export default function SearchFood(){

    const {id} = useParams();

    const [food,setFood] = useState("")
    const [RestData, setRestData] = useState([]);
    const [error, setError] = useState(false);


    useEffect(()=>{

            async function fetchData() {
                try {
                   const swiggyAPI = `https://www.swiggy.com/mapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=${DELHI_LAT}&lng=${DELHI_LNG}&restaurantId=${id}`;
                   const response = await fetch(PROXY_SERVER+swiggyAPI);
                   const data = await response.json();
                   const tempData = data?.data?.cards[5]?.groupedCard?.cardGroupMap?.REGULAR?.cards;
                   if(Array.isArray(tempData)){
                       const filterData = tempData.filter((items)=> 'title' in items?.card?.card)
                       setRestData(filterData);
                   } else {
                       setError(true);
                   }
                } catch (err) {
                    setError(true);
                }
            }

            fetchData();
        },[id])

    const searchTerm = food.trim().toLowerCase();
    const uniqueItems = [...new Map(flattenItems(RestData).map((item)=>[item.id, item])).values()];
    const filteredItems = searchTerm
        ? uniqueItems.filter((item)=> item?.name?.toLowerCase().includes(searchTerm))
        : [];

    return(
        <div className="w-[80%] mx-auto mt-20">
            <div className="relative">
                <Search className="w-6 h-6 text-charcoal/40 absolute left-6 top-1/2 -translate-y-1/2" />
                <input
                    className="w-full py-4 pl-16 pr-6 text-2xl bg-cream rounded-2xl border border-charcoal/15 shadow-sm outline-none transition focus:border-turmeric focus:ring-2 focus:ring-turmeric/50 placeholder:text-charcoal/40"
                    placeholder="Search for dishes"
                    value={food}
                    onChange={(e)=>setFood(e.target.value)}
                ></input>
            </div>

            <div className="mt-10">
                {
                    error
                        ? <p className="text-xl text-charcoal/60">Couldn't load this restaurant's menu right now. Please try again shortly.</p>
                        : searchTerm && filteredItems.length === 0
                            ? <p className="text-xl text-charcoal/60">No dishes found matching "{food}"</p>
                            : filteredItems.map((item)=><RestInfo key={item.id} restData={item}></RestInfo>)
                }
            </div>
        </div>
    )
}
